import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { FIELD__any } from '../../_fields/any/FIELD__any';
import { FIELD__any__list } from '../../_fields/any/FIELD__any__list';
import { FIELD__any__ml_asset } from '../../_fields/any/FIELD__any__ml_asset';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION_INFO__base } from './INVOCATION_INFO__base';

export class INVOCATION_TOOL_VIEW__info extends INVOCATION_INFO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_TOOL_VIEW__INFO;

  /*
   *
   */

  @FIELD__any.init_as_input({}, { generation__has_effect_static: false })
  field__has_affect_on_generation!: FIELD__any;

  @FIELD__any__list.init_as_input({}, { generation__has_effect_static: false })
  field_list__items_amount!: FIELD__any__list;

  @FIELD__any__ml_asset.init_as_input(
    { value: ENUM__string_id_empty.HASH_SHA256, ml_asset_type: ENUM__ml_asset_type.BUNDLE },
    { generation__has_effect_static: false },
  )
  field__ml_asset!: FIELD__any__ml_asset;

  /*
   *
   */
  constructor() {
    super(ENUM__invocation_type.TOOL_VIEW__INFO);
  }

  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    return false;
  }
}
